




import { Component, Vue } from 'vue-property-decorator';
import Layout from './Layout.vue';

import ENV from '@/environment';

@Component({
  components: {
    'v-layout': Layout,
  }
})
export default class App extends Vue {
  env = ENV;

  get region() {
    return this.env.REGION;
  }
}
